import { useMemo } from 'react';

import { Bean, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { MoneyRangeInput, MoneyRangeValue } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';
import { ReceptionServiceFormController } from '../../ReceptionServiceForm';

export type ReceptionServicePriceRangeValue = MoneyRangeValue;

type ReceptionServicePriceMoneyRangeInputProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServicePriceMoneyRangeInput = (props: ReceptionServicePriceMoneyRangeInputProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <MoneyRangeInput
         testId={'priceRange'}
         label={receptionServiceTranslationKeys.shared.form.components.priceMoneyRangeInput.label}
         controller={props.register('priceRange', validationRules)}
         pattern={MoneyPatternType.POSITIVE}
         min={1}
         max={999999.99}
         disabled={props.disabled}
         defaultValue={null}
         nowrap
      />
   );
};
